import { render, staticRenderFns } from "./board_model.vue?vue&type=template&id=2adc2c6b&scoped=true"
import script from "./board_model.vue?vue&type=script&lang=js"
export * from "./board_model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc2c6b",
  null
  
)

export default component.exports